import { render, staticRenderFns } from "./JGridItem.vue?vue&type=template&id=4f3b2956&"
import script from "./JGridItem.vue?vue&type=script&lang=js&"
export * from "./JGridItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports